import React, { useEffect } from "react";
import { RCL } from "../../components/RCL";
import { Section } from "@sunwing/components";
import MessageItem from "./MessageItem";
import styles from "./InboxMessages.module.scss";
import { useApp } from "../../hooks";
import { useRouting } from "../../hooks";

const InboxMessagePage = () => {
    const { userInfo, inboxMessages } = useApp();
    const { setCurrentRoute } = useRouting();

    const activeIndex = parseInt(window.location.search.indexOf("?") + 1 < window.location.search.length
    ? window.location.search.split("=")[1]: "0");

    useEffect(() => {
        if (setCurrentRoute) {
            setCurrentRoute({
                en: { path: "/en/InboxMessage" + window.location.search },
                fr: { path: "/fr/InboxMessage" + window.location.search},
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
          
    return (
        <div className={styles.messages}>
            <Section
                title={RCL({ searchKey: "messages" })?.toUpperCase()}
                titleSize="h1"
                titleAlignment="left">
                <hr/>
                <div>
                    {inboxMessages &&
                        inboxMessages.messages
                        ?.sort((a, b) => ((a.startDateUtc !== null) && -a.startDateUtc.localeCompare(b.startDateUtc)))
                        .map((mes, index) => {
                            return (
                                <MessageItem
                                    key={index}
                                    active={activeIndex===index}
                                    message={mes}
                                    email={userInfo.email}
                                />
                            )
                        })
                    }
                </div>
            </Section>
        </div>
    );
}

export default InboxMessagePage;
export { InboxMessagePage };